import React, {Component} from 'react';
import {Spinner} from "../../Spinner";
import {HELP_LOOKER_CC, LinkToArticle} from "../../help_center/LinkToArticle";
import {ChannelLogo} from "../../channels/ChannelLogo";
import {LOOKER_CC_CHANNEL} from "../../channels/channels";
import {ApiKeyComponent, ApiKeyTypeLookerCC} from "../ApiKey";
import { withTranslation } from 'react-i18next';

// La herramienta de Google, para abrirla desde la caja. Hasta el 02/10 la abría un link del menú
// lateral de la 2.1 («Google Looker Studio», en Herramientas); el menú lo soltó y la puerta quedó acá,
// junto al conector.
const DATA_STUDIO_URL = "https://lookerstudio.google.com/";

/**
 * La caja del conector de Dashbo para Google Data Studio, en Conexiones › Exportación (su única
 * pantalla desde el recorrido de la 2.1, 02/10).
 *
 * Google volvió a llamarlo «Data Studio» el 11/04/2026 (D8 de la tanda). La caja lo nombra así y la
 * descripción dice «antes Looker Studio», para que quien lo conoce con el nombre viejo lo reconozca.
 * Los textos son de la pestaña (`agency_connections.export.*`) y no `looker_cc.*`: esas claves las
 * comparte la lista de cuentas del cliente, que queda para el barrido de nombres de después.
 */
class LookerCCComponentClass extends Component {

    render() {
        const { t } = this.props;
        return (
            <div className="section-body-item -wider box">
                <header className="box-header">
                    <h2 className="box-title"><ChannelLogo width={35} height={35} channel={LOOKER_CC_CHANNEL}/>{t('agency_connections.export.data_studio_title')}</h2>
                </header>
                {this.renderInnerComponents()}
            </div>
        )
    }

    renderNotAccessStatus() {
        const { t } = this.props;
        return <div className="form-row" key="no-access">
            <div className="alert alert-info">
                {t('looker_cc.not_access_message')}
            </div>
        </div>

        // return <div className="form-row">
        //     <div className="alert alert-info">
        //         El conector con Looker Studio no está incluido en tu suscripción actual.
        //     </div>
        // </div>
    }

    renderInnerComponents() {
        const { t } = this.props;
        const elements = [];
        elements.push(<div className="form-row" key="description">
            <label>{t('agency_connections.export.data_studio_text')}&nbsp;&nbsp;➡️<LinkToArticle article={HELP_LOOKER_CC}/></label>
        </div>);
        // Abrir la herramienta no depende de tener el conector en el plan: es el sitio de Google.
        elements.push(<div className="form-row" key="open">
            <a href={DATA_STUDIO_URL} target="_blank" rel="noopener noreferrer"
               data-testid="data-studio-open">
                {t('agency_connections.export.data_studio_open')}
            </a>
        </div>);

        if(this.props.loading) {
            elements.push(<div className="box-loader" key="loader"><Spinner color="positive"/></div>);
            return elements;
        }

        if(!this.props.hasAccessToModule) {
            elements.push(this.renderNotAccessStatus());
            return elements;
        }

        elements.push(<ApiKeyComponent key="button" apiKey={this.props.apiKey}  keyType={ApiKeyTypeLookerCC} />)
        return elements;
    }
}

export const LookerCCComponent = withTranslation()(LookerCCComponentClass);
